import { Icon } from '@timeedit/ui-components';
import { Button, Input } from '@timeedit/ui-components/antd';

type Props = {
  userObjects: string[];
  onChange: (value: any) => void;
};

const UserObjectCell = ({ userObjects, onChange }: Props) => {
  const onUpdateRow = (newVal: string, rowIdx: number) => {
    onChange([
      ...userObjects.slice(0, rowIdx),
      newVal,
      ...userObjects.slice(rowIdx + 1),
    ]);
  };

  const onDeleteRow = (rowIdx: number) => {
    onChange([
      ...userObjects.slice(0, rowIdx),
      ...userObjects.slice(rowIdx + 1),
    ]);
  };

  const onAddRow = () => {
    onChange([...userObjects, '']);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {(userObjects || []).map((userObject, rowIdx) => (
        <div
          key={`user-object-${rowIdx}`}
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <Input
            size="small"
            value={userObject}
            onChange={(e) => onUpdateRow(e.target.value, rowIdx)}
            placeholder="Object extId"
          />
          <Button
            type="link"
            danger
            ghost
            onClick={() => onDeleteRow(rowIdx)}
            disabled={!userObjects || userObjects.length <= 1}
          >
            <Icon id="DeleteOutlined" alt="Delete" />
          </Button>
        </div>
      ))}
      <Button type="link" onClick={onAddRow} style={{ alignSelf: 'flex-end' }}>
        + Add object
      </Button>
    </div>
  );
};

export default UserObjectCell;
